export interface IMemberPreferences {
  campaign: string;
  status: string;
}

export class MemberPreferences {

  public static Test(): MemberPreferences {
    return new MemberPreferences({
      campaign: "abc",
      status: "1"
    });
  }

  public campaign: string;
  public status: string;

  constructor(data: IMemberPreferences) {
    this.campaign = data.campaign;
    this.status = data.status;
  }
}
